import { takeEvery, call, put } from "redux-saga/effects";
import {
  TRIGGER_DIAGRAMS_INTERPRET_REQUEST,
  TRIGGER_DIAGRAMS_INTERPRET_SUCCESS,
  TRIGGER_DIAGRAMS_INTERPRET_FAILURE,
  TRIGGER_DIAGRAMS_RENDER_REQUEST,
  TRIGGER_DIAGRAMS_RENDER_SUCCESS,
  TRIGGER_DIAGRAMS_RENDER_FAILURE,
} from "../actions/diagramsAgentActions";
import {
  triggerDiagramsInterpretApi,
  triggerDiagramsRenderApi,
} from "../apis/diagramsAgentApi";

function* triggerInterpret(action) {
  try {
    const result = yield call(triggerDiagramsInterpretApi, action.payload);
    yield put({ type: TRIGGER_DIAGRAMS_INTERPRET_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: TRIGGER_DIAGRAMS_INTERPRET_FAILURE, error: error.message });
  }
}

function* triggerRender(action) {
  try {
    const result = yield call(triggerDiagramsRenderApi, action.payload);
    yield put({ type: TRIGGER_DIAGRAMS_RENDER_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: TRIGGER_DIAGRAMS_RENDER_FAILURE, error: error.message });
  }
}

export default function* diagramsAgentSaga() {
  yield takeEvery(TRIGGER_DIAGRAMS_INTERPRET_REQUEST, triggerInterpret);
  yield takeEvery(TRIGGER_DIAGRAMS_RENDER_REQUEST, triggerRender);
}
